module.exports = __webpack_public_path__ + "media/images/japan/kaga_picture-8c198bfc292b0d9915318cb1649e684b.png";